module.exports = __webpack_public_path__ + "img/preview-12.77066ca9.png";